export default __webpack_public_path__ + "static/media/logo-ellipse-transparent-260x260.b7d8b702.svg";